import { render, staticRenderFns } from "./investment-instance-selection.vue?vue&type=template&id=db95fc76"
import script from "./investment-instance-selection.vue?vue&type=script&lang=js"
export * from "./investment-instance-selection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports